const nl = {
  'questionnaire.list.submit': 'Bekijk de uitslag',
  'questionnaire.list.isSending': 'Bezig met versturen',
  'questionnaire.list.error':
    'Door een technische storing kunnen we nu helaas geen berekening uitvoeren. Probeer het opnieuw.',
  'questionnaire.result.back': `Terug naar de test`,
  'questionnaire.result.viewExplanation': `Bekijk de toelichting`,
  'questionnaire.result.closeExplanation': `Verberg toelichting`
};
export default nl;
